var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200,0C222.1,0,240,19.1,240,42.7v42.7h160v-42.7C400,19.1,417.9,0,440,0s40,19.1,40,42.7v42.7h40c44.1,0,80,38.3,80,85.3v384c0,47.1-35.9,85.3-80,85.3H120c-44.1,0-80-38.3-80-85.3V170.7c0-47.1,35.9-85.3,80-85.3h40v-42.7C160,19.1,177.9,0,200,0ZM200,341.3c-22.1,0-40,19.1-40,42.7v85.3c0,23.6,17.9,42.7,40,42.7h80c22.1,0,40-19.1,40-42.7v-85.3c0-23.6-17.9-42.7-40-42.7h-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/calendar-day.cc33df1a71637ef5d2198fa8e2961efd.svg";
export { ForwardRef as ReactComponent };